<template>
  <div class="content">
    <div class="header_search">
      <div class="topBtn">
        <Button
          class="item"
          icon="ios-download-outline"
          type="primary"
          @click="exportExcel"
          >导出Excel</Button
        >
      </div>
      <div style="padding-top: 10px; padding-right: 5px">
        <!-- 查询和其他操作 -->
        <Form ref="formValidate" :model="listQuery" :label-width="80">
          <Row>
            <Col span="9">
              <FormItem label="门店">
                <Select
                  ref="select_store"
                  v-model="listQuery.follow_store_id"
                  placeholder="请选择门店"
                  style="width: 30%"
                  @on-change="selectStore"
                >
                  <Option
                    v-for="item in storeList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>

                <Select
                  v-model="listQuery.follow_department_id"
                  placeholder="请选择部门"
                  style="width: 30%"
                  @on-change="selectDepartment"
                >
                  <Option
                    v-for="item in departmentList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>

                <Select
                  v-model="listQuery.follow_agent_id"
                  placeholder="请选择顾问"
                  style="width: 30%"
                >
                  <Option
                    v-for="item in agentList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="4">
              <FormItem
                label="客户信息"
                style="width: 90%"
                class="mb-10"
                prop="phone"
              >
                <Input
                  v-model="listQuery.keywords"
                  required
                  :maxlength="11"
                  placeholder="请输入客户客户名称或者手机"
                ></Input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem label="到店时间" prop="come_date">
                <DatePicker
                  v-model="come_date"
                  type="daterange"
                  :transfer="true"
                  placeholder="请选择"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="4" class="opertionBtn_search">
              <Button
                class="item"
                type="primary"
                icon="ios-search"
                @click="searchList"
                >查询</Button
              >
              <Button class="item" @click="emptyFilter">清空筛选</Button>
              <Button
                class="item"
                type="text"
                style="color: #2d8cf0; display: none"
                >{{ "更多筛选" }}</Button
              >
              <FormItem
                style="margin-bottom: 0; display: none"
                :label-width="0"
              >
                <autoTableItem
                  type="comeStat"
                  :defaultTable="defaultTable"
                  :autoTableData="autoTableData"
                  placeholder="表格展示项"
                  @autoTableRef="autoTableRef"
                ></autoTableItem>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
    <!-- 
    <customerExcel
      :excelTitle="excelTitle"
      :excelSteps="excelSteps"
      :downloadLink="downloadLink"
      :customerExcelShow="customerExcelShow"
      @customerExcelEven="customerExcelEven"
    >
    </customerExcel> -->
    <div class="table_wrap">
      <div style="width: 100%">
        <!--   :width="tableWidth" -->
        <Table
          stripe
          border
          ref="table"
          :columns="tabColumns"
          :loading="tabLoading"
          :data="tabData"
          class="table_style"
          :height="tableHeight"
        ></Table>
        <div style="margin-top: 20px; display: flex; justify-content: flex-end">
          <Page
            show-total
            show-elevator
            show-sizer
            :page-size-opts="pageSizeOpts"
            :page-size="50"
            :transfer="true"
            :total="total"
            :current="listQuery.page"
            @on-change="changePage"
            @on-page-size-change="changeLimit"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import autoTableItem from "@/commonTmp/CRM/CRM_autoTableItem"; //表格自选项
import dropCheckBox from "@/commonTmp/dropCheckBox"; //多选下拉框
import customerExcel from "@/commonTmp/CRM/CRM_customerExcel"; //客户导出
export default {
  name: "comeStat",
  components: {
    autoTableItem,
    dropCheckBox,
    customerExcel,
  },
  data() {
    return {
      defaultStartEntryTime: util.getPreDate(120),
      defaultEndEntryTime: util.getPreDate(0),
      excelTitle: "",
      excelSteps: 1,
      downloadLink: "",
      userId: "",
      tableHeight: 500,
      showBatchAdd: false,
      uploadUrl: api.batchImport,
      uploadHeaders: {
        Authorization: "",
      },
      agentList: [],
      defaultTable: [
        "id",
        "name",
        "phone",
        "follow_store_list",
        "follow_list",
        "member_status",
        "child_birth",
        "budget",
        "come_date",
        "arrival_result",
      ],
      autoTableData: [
        {
          name: "id",
          id: "id",
        },
        {
          name: "客户名称",
          id: "name",
        },
        {
          name: "手机号",
          id: "phone",
        },
        {
          name: "当前状态",
          id: "member_status",
        },
        {
          name: "跟进门店",
          id: "follow_store_list",
        },
        {
          name: "跟进人",
          id: "follow_list",
        },
        {
          name: "预产日期",
          id: "child_birth",
        },
        {
          name: "到店时间",
          id: "come_date",
        },
        {
          name: "客户预算",
          id: "budget",
        },
        {
          name: "到店结果",
          id: "arrival_result",
        },
      ],
      baseData: baseData,
      customerExcelShow: false,
      storeList: [],
      customerGroudList: [],
      departmentList: [],
      channelList: [],
      channelAddList: [],
      come_date: [],
      tabData: [],

      // 列表查询参数
      listQuery: {
        page: 1,
        limit: 50,
        follow_department_id: "",
        follow_agent_id: "",
        follow_store_id: [],
        department_id: "",
        agent_id: "",
        store_id: [],

        keywords: "",
        come_date_start: {},
        come_date_end: {},
      },
      firstEnterStatus: false,
      total: 0,
      pageSizeOpts: [50, 60, 70, 80, 90, 100],
      columnsAll: [
        {
          title: "序号",
          key: "id",
          align: "center",
        },
        {
          title: "客户名称",
          key: "name",
          align: "center",
        },
        {
          title: "手机号",
          align: "center",
          key: "phone",
          width: 140,
          render: (h, params) => {
            const row = params.row;
            const text = row.phone;
            return h("div", [
              h("span", { style: { textAlign: "center" } }, text),
            ]);
          },
        },
        {
          title: "当前状态",
          align: "center",
          key: "member_status",
        },
        {
          title: "跟进门店",
          key: "follow_store_list",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const follow_store_list = row.follow_store_list;
            let html = [];
            if (follow_store_list != null && follow_store_list.length > 0) {
              follow_store_list.forEach((d) => {
                html.push(
                  h("p", [
                    h(
                      "Button",
                      {
                        props: {
                          type: "default",
                          size: "small",
                        },
                        style: {
                          margin: "2px 5px 2px 5px",
                          borderRadius: "12px",
                        },
                      },
                      d.toString().substr(0, 10)
                    ),
                  ])
                );
              });
            }
            return h("div", [html]);
          },
        },
        {
          title: "跟进人",
          key: "follow_list",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const follow = row.follow_list;
            return h("div", [
              h("span", { style: { textAlign: "center" } }, follow.join(",")),
            ]);
          },
          // width:180,
        },

        {
          title: "预产期",
          align: "center",
          key: "child_birth",
          render: (h, params) => {
            const row = params.row;
            const child_birth = row.child_birth;
            let html = "";
            if (child_birth != null && child_birth.length > 0) {
              child_birth.forEach((d) => {
                html += d.toString().substr(0, 10) + "\n";
              });
            }
            return h("div", [h("div", {}, html)]);
          },
        },
        {
          title: "客户预算",
          align: "center",
          key: "budget",
          render: (h, params) => {
            const row = params.row;
            const budget = row.budget;
            let html = [];
            if (budget != null && budget.length > 0) {
              budget.forEach((d) => {
                html.push(
                  h("p", [
                    h(
                      "Button",
                      {
                        props: {
                          type: "default",
                          size: "small",
                        },
                        style: {
                          margin: "2px 5px 2px 5px",
                          borderRadius: "12px",
                        },
                      },
                      d.toString().substr(0, 10)
                    ),
                  ])
                );
              });
            }
            return h("div", [html]);
          },
        },
        {
          title: "到店时间",
          align: "center",
          key: "come_date",
          render: (h, params) => {
            const row = params.row;
            const come_date = row.come_date;
            let html = "";
            if (come_date != null && come_date.length > 0) {
              come_date.forEach((d) => {
                html += d.toString().substr(0, 10) + "\n";
              });
            }
            return h("div", [h("div", {}, html)]);
          },
        },
        {
          title: "到店结果",
          align: "center",
          style:"width:200px",
          key: "arrival_result",
          render: (h, params) => {
            const row = params.row;
            const arrival_result = row.arrival_result;
            let html = [];
            if (arrival_result != null && arrival_result.length > 0) {
              arrival_result.forEach((d) => {
                html.push(
                  h("p", [
                    h(
                      "p",
                      {
                        props: {
                          type: "primary",
                          size: "small",
                        },
                        style: {
                          borderStyle:'solid',
                          backgroundColor:'#4a8ae9',
                          color:'#ffffff',
                          borderColor:'#4a8ae9',
                          margin: "2px 5px 2px 5px",
                          borderRadius: "12px",
                        },
                      },
                      d.toString()
                    ),
                  ])
                );
              });
            }
            return h("div", [html]);
          },
        },
      ],
      startEntryTime: {}, //开始日期设置
      endEntryTime: {}, //结束日期设置
      startDistributionTime: {}, //开始日期设置
      endDistributionTime: {}, //结束日期设置
      // ************ 回访信息 ************
      showAccessInfo: false,
      accessInfoType: "all",
      isModalTitle: 1,
      stylesModal: {
        height: "500px",
      },
      // ************ 客户详情 ************
      showEditUser: false,
    };
  },
  created() {
    this.getList();
    this.apiArrivalStore();
  },
  mounted() {
    this.tableHeight =
      window.innerHeight - this.$refs.table.$el.offsetTop - 220;
    this.tableWidth = window.innerWidth - 270;
  },
  methods: {
    selectStore(value) {
      this.apiArrivalDepartment(value, 1);
    },
    selectDepartment(value) {
      this.apiArrivalAgent(value, this.listQuery.follow_store_id, 1);
    },
    selectStore(value) {
      this.apiArrivalDepartment(value);
    },
    // 门店
    apiArrivalStore() {
      serve.fetchGet(api.arrivalStore, {}).then((data) => {
        this.storeList = data;
        this.storeList.unshift({
          id: "all",
          name: "全部门店",
        });
      });
    },
    /**
     * @selectType 1 是工作台 2 漏斗
     */
    apiArrivalDepartment(follow_store_id) {
      if (follow_store_id > 0) {
        serve
          .fetchGet(api.indexDepartment, {
            follow_store_id: follow_store_id,
            store_id: follow_store_id,
          })
          .then((data) => {
            this.departmentList = data;
            this.departmentList.unshift({
              id: 0,
              name: "全部部门",
            });
          });
      }
    },
    changeLimit(val) {
      this.formItem.limit = val;
      this.getList();
    },
    apiArrivalAgent(follow_department_id, follow_store_id, selectType) {
      if (follow_department_id > 0 && follow_store_id > 0) {
        serve
          .fetchGet(api.arrivalAgent, {
            follow_department_id: follow_department_id,
            department_id: follow_department_id,
            store_id: follow_store_id,
            follow_store_id: follow_store_id,
          })
          .then((data) => {
            if (selectType == 1) {
              this.agentList = data;
              this.agentList.unshift({
                id: 0,
                name: "全部顾问",
              });
            } else {
              this.agentFunnelList = data;
              this.agentFunnelList.unshift({
                id: 0,
                name: "全部顾问",
              });
            }
          });
      }
    },

    // 文件流转换方法
    convertRes2Blob(response) {
      const fileName = util.getNowFormatDate() + "到店结果.xls";
      // 将二进制流转为blob
      const blob = new Blob([response], {
        type: "application/vnd.ms-excel",
      });
      if (typeof window.navigator.msSaveBlob !== "undefined") {
        // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
        window.navigator.msSaveBlob(blob, decodeURI(fileName));
      } else {
        // 创建新的URL并指向File对象或者Blob对象的地址
        const blobURL = window.URL.createObjectURL(blob);
        // 创建a标签，用于跳转至下载链接
        const tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = blobURL;
        tempLink.setAttribute("download", decodeURI(fileName));
        // 兼容：某些浏览器不支持HTML5的download属性
        if (typeof tempLink.download === "undefined") {
          tempLink.setAttribute("target", "_blank");
        }
        // 挂载a标签
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        // 释放blob URL地址
        window.URL.revokeObjectURL(blobURL);
      }
    },
    exportExcel() {
      // var params = {};
      this.$Message.loading({
        content: "正在获取导出链接",
        duration: 100,
      });
      serve.fetchDownload(api.arrivalExport, this.listQuery).then((res) => {
        this.$Message.destroy();
        this.convertRes2Blob(res);
      });
    },

    Close() {
      this.showAccessInfo = false;
    },
    //监听表格自选
    autoTableRef(data) {
      // Lockr.set("comeStat", data);
      let getTableHead = [this.columnsAll[0]];
      for (let item of data) {
        console.log("item", item);
        switch (item) {
          case "name":
            getTableHead.push(this.columnsAll[1]);
            break;
          case "phone":
            getTableHead.push(this.columnsAll[2]);
            break;
          case "member_status":
            getTableHead.push(this.columnsAll[3]);
            break;
          case "follow_list":
            getTableHead.push(this.columnsAll[4]);
            break;
          case "follow_store_list":
            getTableHead.push(this.columnsAll[5]);
            break;
          case "child_birth":
            getTableHead.push(this.columnsAll[6]);
            break;
          case "come_date":
            getTableHead.push(this.columnsAll[7]);
            break;
          case "budget":
            getTableHead.push(this.columnsAll[8]);
            break;
          case "arrival_result":
            getTableHead.push(this.columnsAll[9]);
            break;
        }
      }
      this.tabColumns = getTableHead;
    },

    // 获取列表
    getList() {
      this.tabLoading = true;

      serve
        .fetchGet(api.arrivalLog, this.listQuery)
        .then((res) => {
          var data = res.data;
          this.tabData = data;
          this.total = res.meta.pagination.total;
          this.tabLoading = false;
        })
        .catch((error) => {
          this.tabLoading = false;
          this.$Message.error(error.response.data.message);
        });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    changePage(val) {
      this.listQuery.page = val;
      this.getList();
    },
    // 清空筛选
    emptyFilter() {
      this.defaultEndEntryTime = "";
      this.defaultStartEntryTime = "";
      this.listQuery.page = 1;
      this.listQuery.keywords = "";
      this.checkedShowValue = "";
      this.listQuery.come_date_start = "";
      this.listQuery.come_date_end = "";
      this.firstEnterStatus = false;

      this.getList();
    },
    // 查询
    searchList() {
      this.listQuery.page = 1;
      this.listQuery.come_date_start =
        this.come_date.length == 0 ? "" : util.dateFormat(this.come_date[0]);
      this.listQuery.come_date_end =
        this.come_date.length == 0 ? "" : util.dateFormat(this.come_date[1]); //预产期结束时间

      this.getList();
    },
  },
};
</script>
<style scope>
.mr-t-10 {
  margin-top: 10px;
}
.search_bar {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}
.search_bar_item {
  margin: 4px;
}
.other_search_bar {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}

.table_wrap {
  margin: 12px 12px 12px 0px;
}
.ivu-btn-icon-only {
  margin-left: 4px;
  padding: 0px !important;
  font-size: 18px !important;
}
.ivu-table-cell {
  white-space: pre-line !important;
}
.ivu-drawer-header-inner {
  font-size: 20px !important;
}
.table_tip {
  height: 24px;
  margin: 0 0 10px 0px;
}
.demo-drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
  z-index: 10;
}
.user_info_wrap {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  height: 40px;
  color: #464c5b;
  font-weight: 600;
  font-size: 14px;
  line-height: 40px;
  background: #f8f8f9;
  margin: 10px 0;
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.vertical-center-modal .ivu-modal {
  top: 0;
}
.modal_title {
  text-align: center;
}
.modal_text {
  color: red;
  text-align: center;
  margin-bottom: 16px;
}
.user_info_text_wrap {
  height: 46px;
  padding-top: 10px;
  padding-left: 32px;
  /* line-height: 56px; */

  /* padding: 10px; */
}
.opertionBtn {
  margin-bottom: 20px;
  display: flex !important;
  display: -webkit-flex !important;
  align-items: center;
}
.ivu-form-item-error-tip {
  z-index: 9999;
}
.opertionBtn .item {
  margin-right: 5px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mb-20 {
  margin-bottom: 20px;
}
.TimelineItemTime {
  font-size: 14px;
  font-weight: bold;
}
.TimelineItemContent {
  padding-left: 5px;
}
.topBtn {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 10px;
  border-bottom: 1px solid #e8eaec;
  padding-top: 10px;
  padding-right: 5px;
  background: rgba(249, 249, 249);
}
.topBtn .item {
  margin-left: 5px;
}
.header_search {
  border: 1px solid #e8eaec;
}
.opertionBtn_search {
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.opertionBtn_search .item {
  margin-right: 5px;
}
.table_style .ivu-table-cell {
  padding-left: 2px;
  padding-right: 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Crm/UserManagement/comeStat.vue